module.exports = __webpack_public_path__ + "/assets/img/icon_trackingb7ac62c2.svg";